module.exports = __webpack_public_path__ + "static/b_nubank-0607b39effbbc03311d147288e4312fc.png";